export { EditViewPage } from './EditViewPage';
